import { createContext, useContext } from 'react';

export type AppContextType = {
  isBot: boolean;
  kayakoEnabled: boolean;
  isOutlet: boolean;
};

export const defaultValue: AppContextType = {
  isBot: false,
  kayakoEnabled: false,
  isOutlet: false,
};

export const AppContext = createContext(defaultValue);

export const useAppContext = () => useContext<AppContextType>(AppContext);
